module.exports = __webpack_public_path__ + "media/images/menu-icon-select-233fafc04b8efd76990e3035db89f179.svg";